import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'
import ArticleShow from './views/ArticleShow'
import Nofind from './views/404'
import NewsList from './views/NewsList'
import Home from './views/Home'
import InqCert from './views/InqCert'
import InqCertM from './views/InqCertM'
import CertResult from './views/CertResult'
import CertResultM from './views/CertResultM'
import ApplySociety from './views/ApplySociety'
import InfoQuery from './views/InfoQuery'
import InfoQueryResult from './views/InfoQueryResult'

// import {
//   createRouter,
//   createWebHistory
// } from "vue-router";
Vue.use(Router)
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err);
};
const router = new Router({
  mode: 'history',
  linkExactActiveClass: "selected",
  base: process.env.BASE_URL,

  routes: [
    {
      path: '/inqCert',
      name: 'InqCert',
      component: InqCert
    }, {
      path: '/inqCertM',
      name: 'InqCertM',
      component:InqCertM
    },{
      path: '/certresultM',
      name: 'CertResultM',
      component: CertResultM
    },{
      path: '/certResult',
      name: 'CertResult',
      component: CertResult
    },
    {
      path: '/infoQuery/result/:id',
      name: 'InfoQueryResult',
      component: InfoQueryResult
    },
    {
      path: '/',
      name: 'index',
      component: Index,
      children: [{
          path: '',
          component: Home
        },
        {
          path: '/',
          name: 'home', //首页
          component: Home
        },
        {
          path: '/news/info/:plateId/:articleId', //显示文章内容
          name: 'infoArticle',
          component: ArticleShow
        },
        {
          path: '/news/views/:plateId', //显示更多文章
          name: 'newsList',
          component: NewsList
        },{
          path: '/ApplySociety',
          name: 'ApplySociety',
          component:ApplySociety
        },
      ]
    },
    {
      path: '*',
      name: '/404',
      component: Nofind
    },
  ]
})

// // 添加路由守卫
router.beforeEach((to, from, next) => {
  const isLogin = localStorage.eleToken ? true : false;
  if (to.path == "/inqCert" &&isPhone()) {
    next("/inqCertM");
  } else {
    next();
  }
})
// let router = createRouter({
//   history: createWebHistory(),
//   routes,
//   linkExactActiveClass: "selected"
// })
function isPhone() {
  var mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return mobile != null
}
export default router;
